import {
  DEFAULT_K8_REPORT_UNIT_SECTION,
  K8_REPORT_UNIT_SECTION,
} from 'pages/K8Report/flag.on/constants'

/** Row shape matches ReportTableV2 `classes` entries (school summary preview). */
export const MOCK_CORE_UNITS_CLASSES = [
  {
    classInstance: 'mock-core-1',
    teacherLastName: 'Carroll',
    teacherFirstName: 'Matt',
    className: 'GK Class 1',
    gradeName: 'Kindergarten',
    lessonsCompleted: 5,
    lessonsCompletedCore: 5,
    lessonCountCore: 20,
    hasCompletedLessonLastPeriod: true,
    lastLessonCompleted: 'lesson 2',
    lastLessonCompletedParent: 'unit 1',
    lastLessonCompletedTitle: 'We Watch. We Listen. We Think',
    lastLessonCompletedDate: '2025-09-25',
  },
  {
    classInstance: 'mock-core-2',
    teacherLastName: 'Hodge',
    teacherFirstName: 'Zara',
    className: 'G1 Class 3',
    gradeName: 'Grade 1',
    lessonsCompleted: 0,
    lessonsCompletedCore: 0,
    lessonCountCore: 20,
    hasCompletedLessonLastPeriod: false,
    lastLessonCompleted: '',
    lastLessonCompletedParent: '',
    lastLessonCompletedTitle: '',
    lastLessonCompletedDate: '',
  },
  {
    classInstance: 'mock-core-3',
    teacherLastName: 'Cruz',
    teacherFirstName: 'Jenica',
    className: 'GK Class 2',
    gradeName: 'Kindergarten',
    lessonsCompleted: 5,
    lessonsCompletedCore: 5,
    lessonCountCore: 20,
    hasCompletedLessonLastPeriod: false,
    lastLessonCompleted: 'lesson 5',
    lastLessonCompletedParent: 'unit 1',
    lastLessonCompletedTitle: 'Practice Makes Better',
    lastLessonCompletedDate: '2025-09-23',
  },
]

export const MOCK_SPECIALIZED_UNITS_CLASSES = [
  {
    classInstance: 'mock-spec-1',
    teacherLastName: 'Nguyen',
    teacherFirstName: 'Alex',
    className: 'G5 Class A',
    gradeName: 'Grade 5',
    lessonsCompleted: 3,
    lessonsCompletedCore: 3,
    lessonCountCore: 12,
    hasCompletedLessonLastPeriod: true,
    lastLessonCompleted: 'lesson 1',
    lastLessonCompletedParent: 'Bullying Prevention',
    lastLessonCompletedTitle: 'Recognizing Bullying',
    lastLessonCompletedDate: '2025-10-01',
  },
  {
    classInstance: 'mock-spec-2',
    teacherLastName: 'Patel',
    teacherFirstName: 'Sam',
    className: 'G7 Class B',
    gradeName: 'Grade 7',
    lessonsCompleted: 12,
    lessonsCompletedCore: 12,
    lessonCountCore: 12,
    hasCompletedLessonLastPeriod: false,
    lastLessonCompleted: '',
    lastLessonCompletedParent: '',
    lastLessonCompletedTitle: '',
    lastLessonCompletedDate: '',
  },
]

const MOCK_CORE_TOOLTIPS = {
  classes: 'Classes in this school that report K-8 core unit progress.',
  grade: 'Grade level for each class.',
  progress: 'Lessons marked done out of lessons available for units 1–4.',
  lastLesson: 'The last lesson marked done for the class.',
  markedDone: 'When that lesson was marked done.',
}

const MOCK_SPECIALIZED_TOOLTIPS = {
  classes:
    'Classes in this school that report specialized unit progress (e.g. Bullying Prevention).',
  grade: 'Grade level for each class.',
  progress:
    'Lessons marked done out of lessons available for specialized units.',
  lastLesson: 'The last lesson marked done for the class.',
  markedDone: 'When that lesson was marked done.',
}

/**
 * Full props bundle for ReportTableV2 on school summary (flag.on), keyed by URL unit section.
 * Swap the selector implementation later without changing this shape.
 */
export const MOCK_REPORT_TABLE_BY_UNIT_SECTION = {
  [K8_REPORT_UNIT_SECTION.CORE_UNITS]: {
    activityFilterLabel: 'Recent Activity',
    classes: MOCK_CORE_UNITS_CLASSES,
    classesTooltip: MOCK_CORE_TOOLTIPS.classes,
    displayUnit5Column: false,
    gradeTooltip: MOCK_CORE_TOOLTIPS.grade,
    lastLessonTooltip: MOCK_CORE_TOOLTIPS.lastLesson,
    markedDoneTooltip: MOCK_CORE_TOOLTIPS.markedDone,
    numClassesMarkedLastPeriod: 1,
    numClassesNotMarkedLesson: 1,
    progressCoreTooltip: MOCK_CORE_TOOLTIPS.progress,
    progressTooltip: MOCK_CORE_TOOLTIPS.progress,
    totalClassesCount: 3,
    unitRangeLabel: 'Units 1-4',
    unitRangeOptions: ['Units 1-4', 'Recognizing Bullying and Harassment Unit'],
  },
  [K8_REPORT_UNIT_SECTION.SPECIALIZED_UNITS]: {
    activityFilterLabel: 'Recent Activity',
    classes: MOCK_SPECIALIZED_UNITS_CLASSES,
    classesTooltip: MOCK_SPECIALIZED_TOOLTIPS.classes,
    displayUnit5Column: false,
    gradeTooltip: MOCK_SPECIALIZED_TOOLTIPS.grade,
    lastLessonTooltip: MOCK_SPECIALIZED_TOOLTIPS.lastLesson,
    markedDoneTooltip: MOCK_SPECIALIZED_TOOLTIPS.markedDone,
    numClassesMarkedLastPeriod: 1,
    numClassesNotMarkedLesson: 1,
    progressCoreTooltip: MOCK_SPECIALIZED_TOOLTIPS.progress,
    progressTooltip: MOCK_SPECIALIZED_TOOLTIPS.progress,
    title: 'Specialized Unit progress by Class',
    totalClassesCount: 2,
    unitRangeLabel: 'Digital Well-Being Unit',
    unitRangeOptions: ['Digital Well-Being Unit'],
  },
}

export const getDefaultMockReportTableData = () =>
  MOCK_REPORT_TABLE_BY_UNIT_SECTION[DEFAULT_K8_REPORT_UNIT_SECTION]
